import { createSelector } from 'reselect';
import { getHasThemePresetsAccessScope, getIsUngatedForPresetsInUniversalThemeEditor } from './authSelectors';
import { getThemePath } from './themeSelectors';
import { getActiveThemePresetId } from './themeSettingsSelectors';
import { getIsPresetPanelOpen } from './appSelectors';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { getFromAppName } from './appSelectors';
import { getIsUniversalThemeEditing as getIsUniversalThemeEditingFromAppName } from '../utils/themes';
const getIsUniversalThemeEditing = (state, props) => {
  if ((props === null || props === void 0 ? void 0 : props.isUniversalThemeEditing) !== undefined) {
    return props.isUniversalThemeEditing;
  }
  const fromAppName = getFromAppName(state);
  return getIsUniversalThemeEditingFromAppName(fromAppName);
};
export const getHasThemePresetsAccess = (state, props) => {
  const isScopedForPresets = getHasThemePresetsAccessScope(state);
  const isUniversalThemeEditing = getIsUniversalThemeEditing(state, props);
  const isUngatedForPresetsInUniversalThemeEditor = getIsUngatedForPresetsInUniversalThemeEditor(state);
  const themePath = getThemePath(state) || (props === null || props === void 0 ? void 0 : props.themePath);
  return isScopedForPresets && (!isUniversalThemeEditing || isUngatedForPresetsInUniversalThemeEditor) && themePath === '@hubspot/elevate' // TODO: remove this once other themes support presets
  ;
};
export const getPresetsById = state => state.presets.presetsById;
export const getPresetsRequestStatus = state => state.presets.requestStatus;
export const getFetchActiveThemePresetBufferRequestStatus = state => state.presets.fetchActiveThemePresetBufferRequestStatus;
export const getThemePresetIdToPreview = state => {
  var _state$presets;
  return (_state$presets = state.presets) === null || _state$presets === void 0 ? void 0 : _state$presets.selectedThemePresetId;
};
export const getSelectedThemePresetId = state => {
  const isPresetPanelOpen = getIsPresetPanelOpen(state);
  const activeThemePresetId = getActiveThemePresetId(state);
  const themePresetIdToPreview = getThemePresetIdToPreview(state);
  return isPresetPanelOpen ? themePresetIdToPreview : activeThemePresetId;
};

// Use createSelector to memoize getting presets list rather than creating a new reference
// which allows presets to be used in dependency array without triggering change on every render
export const getPresets = createSelector([getPresetsById], presetsById => Object.values(presetsById));
export const getPresetById = (state, id) => state.presets.presetsById[id];
export const getActiveThemePresetStyles = state => {
  var _getPresetById;
  const activeThemePresetId = getActiveThemePresetId(state);
  return activeThemePresetId !== undefined ? (_getPresetById = getPresetById(state, activeThemePresetId)) === null || _getPresetById === void 0 ? void 0 : _getPresetById.styles : undefined;
};
export const getIgnoreUserThemeOverrides = state => {
  var _state$presets2;
  return (_state$presets2 = state.presets) === null || _state$presets2 === void 0 ? void 0 : _state$presets2.ignoreUserThemeOverrides;
};
export const getActiveThemePresetObjectId = state => {
  var _state$presets3;
  return (_state$presets3 = state.presets) === null || _state$presets3 === void 0 ? void 0 : _state$presets3.activeThemePresetObjectId;
};
export const getHasLoadedPresets = state => getPresetsRequestStatus(state) === RequestStatusTypes.SUCCEEDED && getFetchActiveThemePresetBufferRequestStatus(state) === RequestStatusTypes.SUCCEEDED;
export const getIsLoadingPresets = state => getPresetsRequestStatus(state) === RequestStatusTypes.PENDING || getFetchActiveThemePresetBufferRequestStatus(state) === RequestStatusTypes.PENDING;
export const getPublishedActiveThemePresetId = state => {
  var _state$presets4;
  return (_state$presets4 = state.presets) === null || _state$presets4 === void 0 ? void 0 : _state$presets4.publishedActiveThemePresetId;
};